import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./../../../assets/css/general/NotFound/PageNotFound.css";
import bgImage from "./../../../assets/images/NotFound/PageNotFound.png";

const PageNotFound = ({ onMount }) => {
  const navigate = useNavigate();
    useEffect(() => {
    onMount(true);
    return () => onMount(false);
  }, []);

  return (
    <div className="not-found-container">
      <img src={bgImage} alt="404 background" className="bg-img" />

      <div className="not-found-content">
        <div className="not-found-top">
          <h1 className="error-code">404</h1>
          <h2 className="error-title">Oops... Page Not Found</h2>
        </div>

        <div className="plug-spacer" />
        <div className="not-found-bottom">
          <p className="error-message">
            We're sorry, the page you requested could not be found
            <br />
            Please go back to the homepage
          </p>
          <button className="go-home-btn" onClick={() => navigate("/")}>
            GO HOME
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
